module.exports = "/images/vendor/flag-icon-css/flags/1x1/so.svg?c1561217671d8bdde531130cc9997d03";